import React from 'react';
import { Box } from '@mui/material';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const Image1 = require('../../src/iDo fixed-02.jpg');
const Image2 = require('../../src/iDo fixed-05.jpg');

export default function ImagesComponent() {
  return (
    <>
     <Box sx={{
            boxShadow: '2px 2px 3px 1px rgba(0, 0, 0, 0.25)',
            borderRadius: 5, 
            width:{xs: "50%", sm: "40%",xl:"40%", lg: "50%", md: "80%"},
            height: {xs: "60%", sm: "40%",xl:"80%", lg: "80%", md: "80%"},
            margin: 'auto', 
            backgroundColor: 'white', 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
     }} >
         <Carousel autoPlay={true} height="50%" width="100%" showStatus={false} showThumbs={false} showIndicators={false}  infiniteLoop={true} showArrows={false} >
            <div style={{borderRadius: '10%' , marginTop: 10, marginRight: 5, marginLeft: 5, margingBottom: 10}} >
                 <Box 
                    component='img'
                    src={Image1}
                    alt="iDo Logo"
                    sx={{
                        borderRadius: 5,
                    }}
                />
            </div>
            <div style={{borderRadius: '10%',  marginTop: 10, marginRight: 5, marginLeft: 5, marginBottom: 10}}>
                 <Box 
                    component='img'
                    src={Image2}
                    alt="iDo Logo"
                    sx={{
                        borderRadius: 10,
                    }}
                />
            </div>
        </Carousel>
     </Box>
       
    </>
  );
}
